import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from '../config/axios'

const AuthContext = createContext()

// eslint-disable-next-line react-refresh/only-export-components
export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider')
  }
  return context
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  const logout = useCallback(() => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    setUser(null)
    navigate('/login')
  }, [navigate])

  const loadUser = useCallback(async () => {
    try {
      const response = await axios.get('/auth/perfil')
      setUser(response.data.data)
    } catch (error) {
      console.error('Error al cargar usuario:', error)
      logout()
    } finally {
      setLoading(false)
    }
  }, [logout])

  // Cargar el usuario al montar si hay token guardado
  useEffect(() => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      loadUser()
    } else {
      setLoading(false)
    }
  }, [loadUser])

  const login = async (email, password) => {
    try {
      const response = await axios.post('/auth/login', { email, password })
      const { accessToken, refreshToken, usuario } = response.data.data

      // Guardar tokens (el interceptor de axios los usará automáticamente)
      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)

      // Guardar usuario
      setUser(usuario)

      return { success: true }
    } catch (error) {
      console.error('Error en login:', error)
      console.error('Error response:', error.response)

      const errorMessage = error.message || 'Error al iniciar sesión'

      return {
        success: false,
        message: errorMessage,
      }
    }
  }

  const value = {
    user,
    loading,
    login,
    logout,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
